import { render, staticRenderFns } from "./BauTable.vue?vue&type=template&id=7930358a"
import script from "./BauTable.vue?vue&type=script&lang=js"
export * from "./BauTable.vue?vue&type=script&lang=js"
import style0 from "./BauTable.vue?vue&type=style&index=0&id=7930358a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports